import Page404 from './Page404.component';

export default Page404;
